import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assests/images/logo.png';

function NavbarUi() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const navItems = [
    { name: 'Who We Serve', href: '#' },
    { name: 'About', href: '#' },
    { name: 'Blog', href: '#' },
    { name: 'Press', href: '#' },
  ];

  return (
    <>
      {/* Main Navbar — capsule shape, fixed */}
      <nav
        className={`fixed top-4 left-1/2 -translate-x-1/2 w-[95%] bg-[#0a0a1a] max-w-7xl z-50 transition-all duration-500 ${scrolled
          ? 'backdrop-blur-xl shadow-2xl shadow-black/30'
          : 'backdrop-blur-lg shadow-xl'
          } rounded-full`}
      >
        {/* Desktop layout */}
        <div className="hidden lg:flex items-center justify-between px-8 py-3.5">
          {/* Logo left */}
          <Link to="/">
            <img
              src={logo}
              alt="Your Company Logo"
              className="h-9 w-auto object-contain"
            />
          </Link>

          {/* Centered nav links */}
          <div className="flex items-center gap-12">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-white hover:text-violet-600 text-sm font-medium transition-colors duration-200"
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* Purple CTA right */}
          <Link
            to="/login"
            className="block w-32 text-center bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-violet-500/30"
          >
            Login
          </Link>
        </div>

        {/* Mobile top bar */}
        <div className="lg:hidden flex items-center justify-between px-5 py-3.5">
          <Link to="/" onClick={() => setIsOpen(false)}>
            <img
              src={logo}
              alt="Your Company Logo"
              className="h-8 w-auto object-contain"
            />
          </Link>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-8 h-8 flex flex-col justify-center items-center gap-1.5"
            aria-label="Toggle menu"
          >
            <span
              className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 origin-center ${isOpen ? 'rotate-45 translate-y-2' : ''
                }`}
            />
            <span
              className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 ${isOpen ? 'opacity-0 scale-x-0' : ''
                }`}
            />
            <span
              className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 origin-center ${isOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
            />
          </button>
        </div>
      </nav>

      {/* Mobile fullscreen menu */}
      <div
        className={`lg:hidden fixed inset-0 z-40 bg-[#07071a] flex flex-col transition-all duration-300 ease-in-out ${isOpen
          ? 'opacity-100 pointer-events-auto translate-y-0'
          : 'opacity-0 pointer-events-none -translate-y-2'
          }`}
      >
        {/* Top padding to clear the navbar */}
        <div className="h-[72px] shrink-0" />

        {/* Nav links — evenly spaced, not crammed to center */}
        <div className="flex-1 flex flex-col justify-center gap-2 px-8">
          {navItems.map((item, i) => (
            <a
              key={item.name}
              href={item.href}
              onClick={() => setIsOpen(false)}
              style={{ transitionDelay: isOpen ? `${i * 60}ms` : '0ms' }}
              className={`text-2xl font-normal text-gray-200 hover:text-violet-600 hover:pl-2 transition-all duration-200 py-4 border-b border-white/5 ${isOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
                }`}
            >
              {item.name}
            </a>
          ))}
        </div>

        {/* Login CTA pinned to bottom */}
        <div className="px-8 pb-10 pt-6">
          <Link
            to="/login"
            onClick={() => setIsOpen(false)}
            className="block w-full text-center bg-violet-600 hover:bg-violet-500 active:bg-violet-700 text-white text-lg font-semibold py-4 rounded-full transition-all duration-200 shadow-lg shadow-violet-900/40"
          >
            Login
          </Link>
        </div>
      </div>

      {/* Spacer to prevent content jump under fixed navbar */}
      <div className="h-[72px] lg:h-[80px]" />
    </>
  );
}

export default NavbarUi;